import type { ComponentOptions } from 'vue';
import Vue from 'vue';
import type { Route, RouteConfig } from 'vue-router';
import Router from 'vue-router';
import { toast } from '@mx/vix';
// eslint-disable-next-line import/no-extraneous-dependencies
import DynamicComponent from '@era/edc-vue';
import type { Store } from 'vuex';
import App from './App.vue';
import '@/styles/common.less';
import { Bridge, env, monitor } from '@/common';
import { ExceptionCategory } from '@/common/enum-type';

Vue.use(Router);

const EDCRegistry = window.__EDC__;

EDCRegistry.config({
  env: 'production', // 标记当前项目运行的环境，如 test, staging, production，会影响【我的项目-xx项目-xx组件】中配置的组件下发策略
  projectId: 'com.sankuai.fspfepayresource.pay.edccomponents', // 当前项目的appkey
  // registry: '' // 一般情况用不到；可指定组件的配置请求地址
  // dev: env === 'local' # 开启热更新 hot-reload, EDC 组件开发者在本地项目中调试组件时需要开启，开启后项目的所有组件将请求本地
  // extendEnvKeys: { },// 自定义环境信息，可用于灰度时的自定义环境参数
});

// 将项目 Vue 框架作为公共服务暴露给 EDC 组件使用，可选，VUE组件必须
EDCRegistry.addService('Vue', Vue);
// 还可以暴露更多模块、组件库用于给动态组件使用
// EDCRegistry.addService('MTD', MTD)
// EDCRegistry.addService('add', (a, b) => a + b)
Vue.use(DynamicComponent);
document.documentElement.setAttribute('data-page-style', env.pageStyle);
export default function init(
  routes: RouteConfig[],
  store?: Store<any>,
  options?: ComponentOptions<any>
) {
  const router = new Router({
    routes,
  });

  router.beforeEach((to: Route, from: Route, next: () => void) => {
    toast.show();
    monitor.captureResourceInfoMessage(`${ExceptionCategory.Entry}${to.name}`, {
      name: to.name,
      href: window.location.href,
    });

    next();
  });

  router.beforeResolve((to: Route, from: Route, next: () => void) => {
    toast.hide();
    next();
  });

  router.afterEach((to: Route, from: Route) => {
    if (to.meta?.title) {
      Bridge.setTitle(to.meta.title);
    }
  });

  Vue.config.productionTip = false;
  Vue.config.errorHandler = monitor.vueErrorHandler;

  if (store) {
    new Vue({
      ...options,
      store,
      router,
      render: (h) => h(App),
    }).$mount('#app');
  } else {
    new Vue({
      ...options,
      router,
      render: (h) => h(App),
    }).$mount('#app');
  }
}
